import React from 'react';

import { useScrollState } from '../../../../hooks/useScrollState/useScrollState';
import { IHeroProps } from '../../../../interfaces/hero';
import Header from '../../Globals/Header/Header';

import './TertiaryHero.scss';

const TertiaryHero = ({ title, description, color, bottomContent }: IHeroProps) => {
  const isScrolled = useScrollState(0);

  const heroHeight = isScrolled ? 0 : 431;

  return (
    <>
      <div className={`main-hero tertiary-hero ${color} ${isScrolled ? 'collapsed' : ''}`}>
        <div className="content">
          <Header />
          <div className="title">{title}</div>
          <div className="description">{description}</div>
        </div>
        <div className="bottom-content">{bottomContent}</div>
      </div>
      <div style={{ height: heroHeight, transition: 'height 0.3s ease' }} />
    </>
  );
};

export default TertiaryHero;
